export {default as splash} from './splash/splash'
export {default as antiArchive} from './antiArchive/antiArchive'
export {default as antiArchiveTag} from './antiArchiveTag/antiArchiveTag'
export {default as archive} from './archive/archive'
export {default as roll} from './roll/roll'
export {default as stories} from './stories/stories'
export {default as story} from './story/story'
export {default as info} from './info/info'
export {default as sponsors} from './sponsors/sponsors'
export {default as press} from './press/press'
export {default as licence} from './licence/licence'
export {default as contact} from './contact/contact'
export {default as login} from './login/login'
export {default as news} from './news/news'
export {default as comingSoon} from './comingSoon/comingSoon'
export {default as box} from './box/box'



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/views.js